import { gql } from '@common/hooks';

export const WorksAuthInfoQuery = gql`
  query WorksAuthInfo($userEmail: String!) {
    worksAuthInfo(userEmail: $userEmail) {
      user {
        id
        firstName
        internalTrustedUser
      }
      memberships {
        id
        role
        entity: entityProvider {
          ... on Organization {
            id
            name
            code
            authProviders {
              id
              provider
              name
              url
              active
              visible
            }
          }
          ... on Supplier {
            id
            name
            code
            authProviders {
              id
              provider
              name
              url
              active
              visible
            }
          }
        }
      }
    }
  }
`;

export type WorksAuthInfoQueryType = {
  worksAuthInfo: {
    user: UserType;
    memberships: MembershipType[];
  };
};

export type UserType = {
  id: string;
  firstName: string;
  internalTrustedUser: boolean;
};

export type AuthProviderType = {
  id: string;
  provider: string;
  name: string;
  url: string;
  active: boolean;
  visible: boolean;
};

export type EntityType = {
  id: string;
  name: string;
  code: string;
  authProviders: AuthProviderType[];
};

export type MembershipType = {
  id: string;
  role: string;
  entity: EntityType;
};
